export default __webpack_public_path__ + "static/media/IMG_4872.ac8b79df.jpg";